import React from "react";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import CarRentalOutlinedIcon from "@mui/icons-material/CarRentalOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import { ProductContext } from "../../../Contexts/ProductContext";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Link } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { formatDate } from "../../../utils/dateFormat";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const columns = [
  { id: "userid", label: "#", minWidth: 100 },
  { id: "prdTitle", label: "Product Title", minWidth: 170 },
  { id: "prdImage", label: "Image", minWidth: 170 },
  { id: "prdCategory", label: "Category", minWidth: 170 },
  { id: "createdAt", label: "Created At", minWidth: 170 },
  { id: "action", label: "Action", minWidth: 170 },
];
const Dashboard = () => {
  const { totalProducts, rentProducts, buyProducts } =
    React.useContext(ProductContext);
  const { products, loading } = React.useContext(ProductContext);
  const [value, setValue] = React.useState(0);
  const [rentProductsList, setRentProductsList] = React.useState([]);
  const [buyProductsList, setBuyProductsList] = React.useState([]);
  const [ploading, setpLoading] = React.useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  React.useEffect(() => {
    if (!loading && products.length > 0) {
      setpLoading(true);

      const sortedProducts = [...products].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      const latestProducts = sortedProducts.slice(0, 6);

      const rentItems = latestProducts.filter(
        (product) => product.prdCategory === "Rent"
      );
      const buyItems = latestProducts.filter(
        (product) => product.prdCategory === "Buy"
      );

      setRentProductsList(rentItems);
      setBuyProductsList(buyItems);
      setpLoading(false);
    } else {
      toast.error("No products available");
    }
  }, [loading, products]);

  const formatProductTitle = (title, id) => {
    const formattedTitle = title.split(" ").join("-");
    return `/productDetail/${formattedTitle}/${id}`;
  };
  return (
    <div className="dashboard-content-wrap p-10">
      <div className="dashboard-stats flex gap-4 ">
        <div className="box-stat">
          <div className="bs-left">
            <h5>Total Products</h5>
            <h1>{totalProducts}</h1>
          </div>
          <div className="bs-right">
            <CategoryOutlinedIcon sx={{ fontSize: "40px", color: "#707070" }} />
          </div>
        </div>

        <div className="box-stat">
          <div className="bs-left">
            <h5>Products in Rent</h5>
            <h1>{rentProducts}</h1>
          </div>
          <div className="bs-right">
            <CarRentalOutlinedIcon
              sx={{ fontSize: "40px", color: "#707070" }}
            />
          </div>
        </div>

        <div className="box-stat">
          <div className="bs-left">
            <h5>Products in Buy</h5>
            <h1>{buyProducts}</h1>
          </div>
          <div className="bs-right">
            <InventoryOutlinedIcon
              sx={{ fontSize: "40px", color: "#707070" }}
            />
          </div>
        </div>
      </div>

      <div className="box-card">
        <div className="box-card-title">
          <h1 className="text-xl font-medium mb-7 mt-7">
            For Sale / Rental Products
          </h1>
        </div>
        <div className="box-card-body">
          <Box sx={{ width: "100%", marginTop: "2rem" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="For Sale" {...a11yProps(0)} />
                <Tab label="Rentals" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <div className="flex gap-3 flex-wrap">
                {ploading ? (
                  <p className="text-sm mt-5">Loading products...</p>
                ) : buyProductsList.length > 0 ? (
                  <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    <TableContainer>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                style={{ minWidth: column.minWidth }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {buyProductsList.map((product, index) => (
                            <TableRow hover key={product._id}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{product.title}</TableCell>
                              <TableCell>
                                <img
                                  src={
                                    product.images && product.images.length > 0
                                      ? product.images[0]
                                      : "No Image"
                                  }
                                  alt={product.title} // Added alt attribute for accessibility
                                  className="h-[100px] w-[100px] object-cover rounded-md"
                                />
                              </TableCell>
                              <TableCell>
                                {product.prdCategory === "Buy" ? (
                                  <span className="pCtg-green">For Sale</span>
                                ) : (
                                  <span className="pCtg-red">For Rent</span>
                                )}
                              </TableCell>
                              <TableCell>
                                {formatDate(product.createdAt)}
                              </TableCell>
                              <TableCell>
                                <Link
                                  to={`/admin/dashboard/editProduct/${product._id}`}
                                >
                                  <EditOutlinedIcon />
                                </Link>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 100]}
                      component="div"
                      count={buyProductsList.length} // Correctly set count to buyProductsList
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                ) : (
                  <p>No products available for sale</p>
                )}
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <div className="flex gap-3 flex-wrap">
                {ploading ? (
                  <p className="text-sm mt-5">Loading products...</p>
                ) : rentProductsList.length > 0 ? (
                  <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    <TableContainer>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                style={{ minWidth: column.minWidth }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rentProductsList.map((product, index) => (
                            <TableRow hover key={product._id}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{product.title}</TableCell>
                              <TableCell>
                                <img
                                  src={
                                    product.images && product.images.length > 0
                                      ? product.images[0]
                                      : "No Image"
                                  }
                                  alt={product.title} // Added alt attribute for accessibility
                                  className="h-[100px] w-[100px] object-cover rounded-md"
                                />
                              </TableCell>
                              <TableCell>
                                {product.prdCategory === "Buy" ? (
                                  <span className="pCtg-green">For Sale</span>
                                ) : (
                                  <span className="pCtg-red">For Rent</span>
                                )}
                              </TableCell>
                              <TableCell>
                                {formatDate(product.createdAt)}
                              </TableCell>
                              <TableCell>
                                <Link
                                  to={`/admin/dashboard/editProduct/${product._id}`}
                                >
                                  <EditOutlinedIcon />
                                </Link>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 100]}
                      component="div"
                      count={buyProductsList.length} // Correctly set count to buyProductsList
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                ) : (
                  <p>No products available for rent</p>
                )}
              </div>
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
